import { BrowserRouter as Router } from 'react-router-dom';
import { useAuthState } from "react-firebase-hooks/auth";
import { useLocation } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import { styled } from '@mui/system';

import { auth } from "./firebase.js";
import SignIn from "./components/SignIn.js";
import Display from './components/Display.js';
import { AlertProvider } from './AlertContext';
import './App.css';


// alert のスタイルクラス
const StyledAlert = styled(Alert)({
  width: '50%',
  margin: '0 auto',
  marginBottom: '20px',
});

const App = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const adminId = urlParams.get('adminId');
  const [user] = useAuthState(auth);
  return <div> 
    { 
      !adminId ? 
        <StyledAlert severity="error">
          URLの設定が不正です。管理者にお問い合わせください。
        </StyledAlert>
      :
      (
        user ? 
          <Display adminId={adminId}/> : 
          <SignIn />
      )
    } 
    </div>;
}

export default function AppWithRouter() {
  return (
    <AlertProvider>
      <Router>
        <App />
      </Router>
    </AlertProvider>
  );
}